export default __webpack_public_path__ + "static/media/4.08bd3e67.jpg";